<div class="button-container">
  <button pButton type="button" class="user-menu-button" (click)="toggleOverlay($event)">
    <i class="ri-user-fill"></i>
  </button>

  <button pButton type="button" class="arrow-button" (click)="toggleOverlay($event)">
    <i class="ri-arrow-drop-down-line" *ngIf="!isOpen"></i>
    <i class="ri-arrow-drop-up-line" *ngIf="isOpen"></i>
  </button>
</div>
<p-overlayPanel #userMenuPanel>
  <div class="menu-options">
    <button
      pButton
      type="button"
      class="p-button-text"
      i18n-label="Account settings menu item"
      label="Account Settings"
      (click)="navigateToAccountSettings()">
    </button>

    <button
      pButton
      type="button"
      class="p-button-text"
      i18n-label="Log out menu item"
      label="Log Out"
      (click)="onLogout()">
    </button>
  </div>
</p-overlayPanel>